import { capitalize } from 'lodash'
import { observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import * as R from 'ramda'

class QuestionSlide {
    id = uuidv4()

    kind = 'QuestionSlide'

    pageQuestionId

    chartType

    @observable comparisonSurveyIds

    @observable benchmarks

    ranking

    locked

    @observable excludeNonNumeric

    comment

    hasBenchmarks

    coding

    constructor({
        pageQuestionId,
        chartType,
        benchmarks = [],
        comparisonSurveyIds = [],
        ranking,
        question,
    }) {
        const { questionTypeCode } = question
        this.pageQuestionId = pageQuestionId
        this.chartType = chartType
        this.ranking = ranking

        this.benchmarks = benchmarks
        this.hasBenchmarks = benchmarks.length > 0

        this.comparisonSurveyIds = comparisonSurveyIds
        this.hasComparisons = comparisonSurveyIds.length > 0

        if (questionTypeCode === 'CH' && R.pathOr([], ['optionSet', 'options'], question).some(({ isLocked }) => isLocked)) {
            this.locked = true
        } else if (
            questionTypeCode === 'RD'
                && R.pathOr([], ['optionSet', 'options'], question).some(({ isLocked }) => isLocked)
                && question.optionSet.options.every(({ reportingValue }) => R.isNil(reportingValue))
        ) {
            this.locked = true
        }
        if (
            questionTypeCode === 'TB'
                && !!(question.optionSetX.hasNumericCodes)
                && question.optionSetX.options.some(({ reportingValue }) => R.isNil(reportingValue))
        ) {
            this.excludeNonNumeric = true
        }

        if (['TX', 'TA'].includes(questionTypeCode)) {
            this.coding = []
        }
    }

    arrayOrUndefined = (arr) => {
        return Array.isArray(arr) && arr.length > 0
            ? arr.filter(({ checked }) => checked).map(({ value }) => capitalize(value))
            : undefined
    }

    toJSON() {
        return {
            kind: this.kind,
            pageQuestionId: this.pageQuestionId,
            chartType: this.chartType,
            comparisonSurveyIds: this.arrayOrUndefined(this.comparisonSurveyIds.slice()),
            benchmarks: this.arrayOrUndefined(this.benchmarks.slice()),
            ranking: this.ranking,
            locked: this.locked,
            excludeNonNumeric: this.excludeNonNumeric,
            coding: this.coding,
            comment: this.comment,
        }
    }
}

export default QuestionSlide
